import React from 'react'
import { Switch as MuiSwitch, Typography } from '@mui/material'
import { styled } from '@mui/material/styles'

const CustomSwitch = styled(MuiSwitch)(({ theme }) => ({
    width: '105px',
    height: '25px',
    padding: 0,
    margin: theme.spacing(1),
    borderRadius: '13px',
    border: 'solid 1px #d2d2d9',
    '& .MuiSwitch-switchBase': {
        padding: '1px',
        '&.Mui-checked': {
            transform: 'translateX(50px)',
            color: theme?.palette?.common?.white,
            '& + .MuiSwitch-track': {
                backgroundColor: '#fbfbfd !important',
                opacity: 1,
                border: 'none',
            },
        },
    },
    '& .MuiSwitch-track': {
        borderRadius: 26 / 2,
        backgroundColor: '#fbfbfd !important',
        opacity: 1,
        transition: theme.transitions.create(['background-color', 'border']),
    },
}))

const Switch = ({ onChange, value, disabled, onLabel, offLabel, theme }) => {
    const icon = (
        <div style={{ position: 'relative' }}>
            <div style={{ position: 'absolute', top: 0, right: -35 }}>
                <Typography style={{ color: '#d2d2d9', fofontSize: '14px' }}>
                    {onLabel}
                </Typography>
            </div>

            <div
                style={{
                    width: '50px',
                    height: '21px',
                    borderRadius: '20px',
                    backgroundColor: '#d2d2d9',
                }}
            >
                <Typography
                    style={{
                        color: theme?.palette?.common?.white,
                        fontSize: '14px',
                    }}
                >
                    {offLabel}
                </Typography>
            </div>
        </div>
    )

    const checkedIcon = (
        <div style={{ position: 'relative' }}>
            <div style={{ position: 'absolute', top: 0, left: -35 }}>
                <Typography style={{ color: '#d2d2d9', fontSize: '14px' }}>
                    {offLabel}
                </Typography>
            </div>
            <div
                style={{
                    width: '50px',
                    height: '21px',
                    borderRadius: '20px',
                    backgroundColor: '#d2d2d9',
                }}
            >
                <Typography
                    style={{
                        color: theme?.palette?.common?.white,
                        fontSize: '14px',
                    }}
                >
                    {onLabel}
                </Typography>
            </div>
        </div>
    )

    return (
        <CustomSwitch
            disabled={disabled}
            checkedIcon={checkedIcon}
            icon={icon}
            checked={value}
            onChange={onChange}
            disableRipple
        ></CustomSwitch>
    )
}

export default Switch
